import React from 'react'
import { NextSeo } from 'next-seo'

import LinqAlphaLogoWhite from '../Svg/LinqAlphaLogoWhite'
import LinqAlphaLogo from '../Svg/LinqAlphaLogo'
import LightningIcon from '../Svg/LightningIcon'
import CalendarIcon from '../Svg/CalendarIcon'

import { Icons } from '@/components/Shared/icons'

interface AuthLayoutProps {
  children: React.ReactNode | React.ReactElement
  title: string
}
const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title }) => {
  return (
    <>
      <NextSeo title={`${title} | LinqAlpha`} />
      <div className="grid grid-cols-1 lg:grid-cols-5 bg-gradient-to-b bg-primary-accent text-white">
        {/* The brand panel is pinned to the same navy in both themes, so its text is
            pinned too — label.assistive flips to #878A93 and drops to 2.07:1 here. */}
        <div className="pt-14 px-4 hidden lg:block lg:col-span-3 lg:px-0 lg:pt-0 lg:max-w-[800px] lg:m-auto">
          <div className="px-10 mt-20 2xl:px-0 2xl:mt-0">
            <div>
              <LinqAlphaLogoWhite className="w-48 mb-24" />
            </div>
            <div className="text-2xl font-medium">
              Intelligent Search for Investment Research Professionals
            </div>
            <div className="mt-4 text-[#DBDCDF] font-light max-w-xl text-lg">
              Unlock the power of intelligent search tailored for hedge fund analysts! With
              LinqAlpha, hedge funds can streamline their investment research process, achieving
              unparalleled accuracy and efficiency.
            </div>
            <div className="mt-24">
              <div className="text-2xl font-medium">Start Exploring</div>
              <div className="grid md:grid-cols-3 gap-4 mt-8">
                <div className="">
                  <dl className="grid max-w-xl gap-x-8 gap-y-10 lg:max-w-none lg:gap-y-16">
                    <div className="relative pl-16">
                      <dt className="text-base font-semibold leading-7">
                        <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-600">
                          <Icons.Chat className="h-6 w-6 fill-white" aria-hidden="true" />
                        </div>
                        Transcript Search
                      </dt>
                      <dd className="mt-2 text-base text-tint-brand_body leading-7">
                        Search earnings transcripts, financial filings, and news in real time to
                        power your investment research.
                      </dd>
                    </div>
                  </dl>
                </div>
                <div className="">
                  <dl className="grid max-w-xl gap-x-8 gap-y-10 lg:max-w-none lg:gap-y-16">
                    <div className="relative pl-16">
                      <dt className="text-base font-semibold leading-7">
                        <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-600">
                          <CalendarIcon className="h-6 w-6" aria-hidden="true" fill="#FFFFFF" />
                        </div>
                        Earnings Management
                      </dt>
                      <dd className="mt-2 text-base text-tint-brand_body leading-7">
                        Manage your own earnings schedule and get first take and summary of earnings
                      </dd>
                    </div>
                  </dl>
                </div>
                <div className="">
                  <dl className="grid max-w-xl gap-x-8 gap-y-10 lg:max-w-none lg:gap-y-16">
                    <div className="relative pl-16">
                      <dt className="text-base font-semibold leading-7">
                        <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-600">
                          <LightningIcon className="h-6 w-6" aria-hidden="true" fill="#FFFFFF" />
                        </div>
                        Workflow Automation
                      </dt>
                      <dd className="mt-2 text-base text-tint-brand_body leading-7">
                        Automate your research workflow with intelligent AI — achieve results
                        faster, with greater accuracy and ease.
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-2 bg-white flex flex-col items-center justify-center relative pb-4">
          <div className="z-50">
            <LinqAlphaLogo className="lg:hidden absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32" />
            <div className={'flex justify-center items-center h-full min-h-screen'}>
              <div className={'rounded-xl bg-white w-[95vw] sm:w-[420px]'}>{children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AuthLayout
